import React from "react";
import {
  Box,
  Card,
  CardStackSection,
  Heading,
  Hidden,
  Stack,
  Text,
} from "@origin-digital/ods-core";
import { useResponsiveGuardStatus } from "./useResponsiveGuardStatus";
import { useResponsiveBelowLg } from "src/hooks";

export const GlobalResponsiveGuard: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const shouldShowPresentation = useResponsiveGuardStatus();

  const isBelowLg = useResponsiveBelowLg();

  if (!shouldShowPresentation) {
    return <>{children}</>;
  }

  if (!isBelowLg) {
    return <>{children}</>;
  }

  // Otherwise, show slate
  return (
    <>
      {/* Header */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="full"
        paddingX="large"
        backgroundColor="white"
      >
        {/* Logo + Nav */}
        <Box display="flex" justifyContent="space-between">
          {/* Logo */}
          <Box paddingY="medium">
            <Box display="flex">
              <img
                src="https://www.originenergy.com.au/cdn/images/originenergy/image/upload/logos/origin_favicon-32x32.svg"
                height={24}
                width={24}
                style={{ marginRight: "8px" }}
              />
              <Text weight="medium" tone="neutralDark">
                Origin Connect
              </Text>
            </Box>
          </Box>
          {/* End Logo */}
        </Box>
        {/* End Logo + Nav */}
      </Box>
      {/* End Header */}

      {/* Content */}
      <Hidden above="lg">
        <CardStackSection cardWidth="large">
          <Card>
            <Stack alignX="center">
              <img
                height={96}
                width={96}
                src="https://www.originenergy.com.au/cdn/images/originenergy/image/upload/pictograms/pictogram_maintenance.svg"
              />
              <Stack alignX="center">
                <Heading variant="h4">We're working on it!</Heading>
                <Text align="center">
                  Currently, Origin Connect is best viewed on larger screens.
                  We're still working on refining the mobile and tablet
                  experience, so please check back soon!
                </Text>
              </Stack>
            </Stack>
          </Card>
        </CardStackSection>
      </Hidden>
      {/* End Content */}
    </>
  );
};
